var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 15,
    fill: "#491ACB",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.024 32C25.3242 32 28.9218 28.9922 29.8279 24.9657C30.0135 24.141 30.1063 23.7286 29.8052 23.3523C29.5042 22.976 29.017 22.976 28.0427 22.976H21.024M21.024 32C16.0402 32 12 27.9598 12 22.976C12 18.6758 15.0078 15.0782 19.0343 14.1721C19.859 13.9865 20.2714 13.8937 20.6477 14.1948C21.024 14.4958 21.024 14.983 21.024 15.9573V22.976M21.024 32V22.976V32Z",
    fill: "#491ACB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.024 32C25.3242 32 28.9218 28.9922 29.8279 24.9657C30.0135 24.141 30.1063 23.7286 29.8052 23.3523C29.5042 22.976 29.017 22.976 28.0427 22.976H21.024M21.024 32C16.0402 32 12 27.9598 12 22.976C12 18.6758 15.0078 15.0782 19.0343 14.1721C19.859 13.9865 20.2714 13.8937 20.6477 14.1948C21.024 14.4958 21.024 14.983 21.024 15.9573V22.976M21.024 32V22.976",
    stroke: "#491ACB",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5541 17.0265C30.7305 14.9359 29.0641 13.2695 26.9735 12.4459C25.8783 12.0145 25.3307 11.7987 24.6653 12.2517C24 12.7047 24 13.4456 24 14.9275V16.9565C24 18.3912 24 19.1086 24.4457 19.5543C24.8914 20 25.6088 20 27.0435 20H29.0725C30.5544 20 31.2953 20 31.7483 19.3347C32.2013 18.6693 31.9855 18.1217 31.5541 17.0265Z",
    fill: "#491ACB",
    stroke: "#491ACB",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePieChart);
export default __webpack_public_path__ + "static/media/active_pie_chart.f6e2200ee0ac1cc96c1149c7b17d22e6.svg";
export { ForwardRef as ReactComponent };